import axios from "axios";

const options = {
  baseURL: "https://v2.simemr.com///",
  headers: {
    "Content-Type": "application/json",
  },
};

const optionsLogin = {
  baseURL: "https://v2.simemr.com/",
  headers: {
    "Content-Type": "text/plain",
  },
};

/**
 *
 * @param {*} url
 * @param {*} params
 */
async function request(_request) {
  try {
    const response = await axios(_request);

    return response.data;
  } catch (error) {
    let response = error.response;

    if (response && response.status >= 400 && response.status < 500) {
      throw response.data;
    }

    response = { error: { message: response.statusText } };

    throw response;
  }
}

/**
 *
 * @param {*} request
 */
function get(params) {
  return request({
    ...params,
    method: "GET",
    ...options,
  });
}

/**
 *
 * @param {*} request
 */
function post({ url, body }) {
  return request({
    method: "POST",
    url,
    ...options,
    data: body,
  });
}

/**
 *
 * @param {*} request
 */
function postLogin({ url, body }) {
  return request({
    method: "POST",
    url,
    ...optionsLogin,
    data: body,
  });
}

export default {
  get,
  post,
  postLogin,
};
